import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { FormLabel, GridLegacy, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { talenV5 } from "../../../variables/app";
import FormTextTC from "../../../components/Forms/FormTextTC";

function Translations() {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <GridLegacy container spacing={1}>
        <GridLegacy item lg={6} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={12}>
                  <Typography component={"h3"}>
                    <TranslationWrapper
                      tDefault={"Description"}
                      tKey={"tags.form.translations.label.vertalingOmschrijving"}
                    />
                  </Typography>
                </GridLegacy>
                {Object.keys(talenV5).map((objKey) => {
                  let language = talenV5[objKey];

                  return (
                    <FormTextTC
                      key={objKey}
                      label={
                        <FormLabel>
                          <TranslationWrapper tDefault={language.label} tKey={"global." + language.transKey} />
                        </FormLabel>
                      }
                      name={"translations." + objKey + ".name"}
                    />
                  );
                })}
              </GridLegacy>
            </CardBody>
          </Card>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

export default Translations;
